/**
 * A pilha de camadas sobre a página, sem DOM: quem responde ao Esc, ao Tab e ao clique no fundo quando
 * uma `Sobreposicao` abre sobre outra — o visor de imagem sobre a escolha da foto, por exemplo.
 *
 * Cada camada tem um número, dado ao abrir. A de cima é a última da pilha, e só ela fala: se o Esc
 * fechasse as duas, quem abriu o visor para conferir um detalhe perderia a tela de escolha junto.
 */
export type Pilha = readonly number[];

export const PILHA_VAZIA: Pilha = [];

/** A camada passa a ser a de cima. Abrir duas vezes a mesma não a duplica: ela só sobe ao topo. */
export function empilhar(pilha: Pilha, id: number): Pilha {
  return [...pilha.filter((x) => x !== id), id];
}

/** A camada sai, esteja onde estiver. As outras mantêm a ordem; a de cima passa a ser a que sobrar por último. */
export function desempilhar(pilha: Pilha, id: number): Pilha {
  return pilha.filter((x) => x !== id);
}

/** A camada de cima, ou nada quando não há camada aberta. */
export function topo(pilha: Pilha): number | undefined {
  return pilha[pilha.length - 1];
}

/** Só a de cima responde ao teclado e ao fundo. */
export function ehDoTopo(pilha: Pilha, id: number): boolean {
  return topo(pilha) === id;
}

/**
 * A rolagem da página fica presa enquanto houver alguma camada, e só volta quando a **última** fecha:
 * soltá-la ao fechar o visor deixaria a página rolar por trás da tela de escolha, que continua aberta.
 */
export function rolagemPresa(pilha: Pilha): boolean {
  return pilha.length > 0;
}
